/**
 * GiftInfoRemapper
 *
 * Maps GiftInfoDto (data layer) → GiftInfoEntity (domain).
 * Flutter source: lib/data/models/gift_info.dart
 *
 * Note: Flutter's `path` getter (Env.giftsBucket + thumbnail) is computed and NOT on the wire.
 */
import type { GiftInfoDto } from '@/data/dtos/info/giftInfoDto';
import type { JsonObject } from '@/data/types/json';
import type { GiftInfoEntity } from '@/domain/entities/info/giftInfoEntity';

export class GiftInfoRemapper {
  static fromDto(dto: GiftInfoDto): GiftInfoEntity {
    return { ...dto };
  }

  static fromJson(data: JsonObject): GiftInfoDto {
    return {
      name: (data['name'] as string | undefined) ?? '',
      thumbnail: (data['thumbnail'] as string | undefined) ?? '',
      coins: (data['coins'] as number | undefined) ?? 0,
      // Flutter default: 1 (GiftInfo({this.instances = 1}))
      instances: (data['instances'] as number | undefined) ?? 1,
    };
  }

  static fromJsonList(dataList: JsonObject[]): GiftInfoDto[] {
    return dataList.map(GiftInfoRemapper.fromJson);
  }
}
